import { Typography } from "@mui/material";

import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";

import {
  ImageContainer,
  MainContainer,
  WorkerDescription,
  WorkerImage,
} from "./styles.styled";
import { WorkerInfo, WorkerInfoProps } from "./WorkerInfo";

interface WorkerCardProps extends WorkerInfoProps {
  img: string;
  name: string;
  role: string;
}

export const WorkerCard = ({ img, name, role, ...rest }: WorkerCardProps) => {
  const { isDesktopXl, isDesktop } = useMediaQueryBreakpoint();

  return (
    <MainContainer>
      <ImageContainer>
        <WorkerImage
          src={img}
          alt={name}
          style={{
            width: "100%",
            height: "auto",
          }}
        />

        <WorkerInfo {...rest} />
      </ImageContainer>

      <WorkerDescription>
        <Typography
          variant={
            isDesktopXl
              ? "heading_h3_medium_desktop"
              : isDesktop
                ? "heading_h5_medium_desktop"
                : "paragraph_xlarge_medium"
          }
          align="left"
        >
          {name}
        </Typography>

        <Typography
          variant={
            isDesktopXl
              ? "paragraph_large_regular"
              : isDesktop
                ? "paragraph_small_regular"
                : "paragraph_xsmall_regular"
          }
          align="left"
        >
          {role}
        </Typography>
      </WorkerDescription>
    </MainContainer>
  );
};
